<div class="conditional__options-list">
  @for (option of surveyConditionalsService.questionSelected$().choices; track option.id) {
    <mat-checkbox
      class="conditional__options-list-option"
      color="primary"
      [checked]="surveyConditionalsService.conditionFormValues$().valueToMatch?.includes(option.id)"
      [labelPosition]="'before'"
      (change)="surveyConditionalsService.onFormMultiOptionChanged($event, option.id)"
    >
      @if (option.stimulus?.mediaId) {
        <empathy-shared-stimulus [stimulus]="[option.stimulus]" [readonly]="true" [height]="35" [width]="42"></empathy-shared-stimulus>
      }
      {{ option | optionTextByType: surveyConditionalsService.questionSelected$() }}
    </mat-checkbox>
  }

  @if (surveyConditionalsService.questionSelected$().useOtherInd && surveyConditionalsService.questionSelected$().type !== questionType.RankSort) {
    <mat-checkbox
      [checked]="surveyConditionalsService.conditionFormValues$().valueToMatch?.includes('OTHER')"
      class="conditional__options-list-option"
      color="primary"
      [labelPosition]="'before'"
      (change)="surveyConditionalsService.onFormMultiOptionChanged($event, 'OTHER')"
    >
      {{ surveyConditionalsService.questionSelected$().otherLabel | toPlainText }}
    </mat-checkbox>
  }
</div>
